import { render } from "./Card.vue?vue&type=template&id=771a406c"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=771a406c&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__